import {EndoDiagnosisToothDetailScDataModel} from './endo-diagnosis-tooth-detail-sc-data.model';

export class EndoDiagnosisToothDetailDataModel {
  EndoDiagToothDetailID: string;
  EndoDiagID: string;
  ParentFieldName: string;

  dataEndoDiagnosisToothDetailSCs: EndoDiagnosisToothDetailScDataModel[];
}
